const Helper = {
    URI:action=>{
        return `/oauth2/api.php?action=${action}`;
    },
    VIMEO:(action,params=[])=>{
        return `/videos/api.php?action=${action}${params.length>0?'&'+params.join('&'):''}`;
    }
};
export default Helper;